import { h, Component } from 'preact';
import style from './style.scss';
import Spinner from '../../global/spinner';
// eslint-disable-next-line import/no-cycle
import Activity from '../activity';
import Pagination from '../../pagination';

import { consts } from '../../../utils/consts';

import { langPack } from '../../../utils/langPack';


class AllActivity extends Component {
  render({ activity = [], total, currentPage, changePage, loading, timeOffset, locale, pro, badges = {} }) {
    return (
      <div className={`${style.activityList} ${!this.props.client && style.withSorting}`}>
        <div className={style.inner}>
          {activity.length > 0 && !loading && activity.map(activity => (
            <Activity key={activity.id} activity={activity} client={this.props.client} timeOffset={timeOffset}
                      locale={locale} pro={pro} badges={badges[activity.id] || {}}/>
          ))}
          {activity.length === 0 && !loading && (
            <div className={style.empty}>{langPack[locale].PROFILE.NO_RECENT_ACTIVITY}</div>
          )}

          {loading && (
            <div className={style.spinnerContainer}>
              <Spinner/>
            </div>
          )}
        </div>
        {activity.length < total && (
          <div className={style.pagination}>
            <Pagination
              total={total}
              onChange={changePage}
              current={currentPage}
              pageSize={consts.PAGE_SIZE}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AllActivity;



// WEBPACK FOOTER //
// ./components/profile/all-activity/index.js